import React from "react";

export const AccessDenied: React.FC = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="text-center">
      <h2 className="text-2xl font-medium text-gray-700 mb-2">Access Denied</h2>
      <p className="text-gray-500">
        You do not have permission to access this page.
      </p>
    </div>
  </div>
);
